import React from 'react';
import styles from './external-members-table-wrapper.scss';

export const ExternalMembersTableWrapper: React.FC<React.PropsWithChildren> = ({ children }) =>
  <div className={styles.tileWrapper}>
    {children}
  </div>;
